/**
 * ItemsBoughtCard.js
 *
 * Displays how many items the team has bought, out of the maximum allowed.
 */

import React from "react";
import Card, { CardHeader, CardTitle, CardContent } from "../../../components/ui/Card";

const ItemsBoughtCard = ({ totalItems, maxItems }) => {
    return (
        <Card className="h-full flex flex-col bg-zinc-900 border-zinc-700 shadow-md">
            <CardHeader className="pb-2">
                <CardTitle className="flex items-center gap-2 text-sm text-zinc-400">
                    Bought
                </CardTitle>
            </CardHeader>

            <CardContent className="flex-1 flex items-end justify-end">
                <div className="text-6xl font-extrabold text-yellow">
                    {totalItems}
                    {maxItems !== undefined && <span className="text-3xl text-zinc-500"> / {maxItems}</span>}
                </div>
            </CardContent>
        </Card>
    );
};

export default ItemsBoughtCard;
